/* tg-search-overlay.js
   Mobile full-screen search overlay. Opens from the existing mobile header
   search button (#Search-drawer-button-mobile-nav, rendered by search-drawer).
   Without this script that button still opens the standard search drawer. */
(function () {
  'use strict';

  var TRIGGER_ID = 'Search-drawer-button-mobile-nav';
  var OVERLAY_ID = 'TgSearchOverlay';
  var DATA_ID = 'tg-search-prompts-data';
  var DEFAULT_SEARCH_URL = '/search';
  var MAX_CHIPS = 5;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  var overlay = null;
  var trigger = null;
  var lastFocus = null;
  var hideTimer = null;

  function isMobile() {
    return mq ? mq.matches : window.innerWidth <= 767;
  }

  function getOverlay() {
    if (!overlay) {
      overlay = document.getElementById(OVERLAY_ID);
      /* Move to <body> so it sits in the root stacking context, above the
         header section and the mobile drawer (same approach as the drawer). */
      if (overlay && overlay.parentNode !== document.body) {
        document.body.appendChild(overlay);
      }
    }
    return overlay;
  }

  function readData() {
    var el = document.getElementById(DATA_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function renderChips(root) {
    var wrap = root.querySelector('.tg-search-overlay__chips');
    var list = root.querySelector('.tg-search-overlay__chip-list');
    var salon = root.querySelector('.tg-search-overlay__chip--salon');
    if (!list || !wrap) return;

    var data = readData();
    var searchUrl = (data && typeof data.searchUrl === 'string' && data.searchUrl) || DEFAULT_SEARCH_URL;
    var terms = data && Array.isArray(data.trending) ? data.trending : [];

    if (salon && data && typeof data.salonUrl === 'string' && data.salonUrl) {
      salon.setAttribute('href', data.salonUrl);
    }

    list.textContent = '';
    var count = 0;
    for (var i = 0; i < terms.length && count < MAX_CHIPS; i++) {
      var term = typeof terms[i] === 'string' ? terms[i].trim() : '';
      if (!term) continue;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'tg-search-overlay__chip';
      a.href = searchUrl + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
      a.textContent = term;
      li.appendChild(a);
      list.appendChild(li);
      count++;
    }
    /* Hide the "Trending" heading + list when there is nothing to show;
       the salon chip lives outside this wrapper, so it always stays. */
    wrap.hidden = count === 0;
  }

  function closeDrawerIfOpen() {
    var drawer = document.getElementById('tg-mob-drawer');
    if (drawer && drawer.classList.contains('is-open')) {
      var closeBtn = document.getElementById('tg-mob-close');
      if (closeBtn) closeBtn.click();
    }
  }

  function closeNativeSearchDrawer() {
    var details = trigger && trigger.closest ? trigger.closest('details') : null;
    if (details && details.open) details.removeAttribute('open');
  }

  function open() {
    var root = getOverlay();
    /* Ignore only if already fully open; during the close fade-out, reopen. */
    if (!root || (!root.hidden && root.classList.contains('is-open'))) return;

    closeDrawerIfOpen();
    clearTimeout(hideTimer);
    renderChips(root);

    root.hidden = false;
    /* Force a reflow so the transition runs from the closed state. */
    void root.offsetWidth;
    root.classList.add('is-open');
    document.documentElement.classList.add('tg-search-open');
    document.body.classList.add('tg-search-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    if (window.TGSearchPrompts && typeof window.TGSearchPrompts.init === 'function') {
      try { window.TGSearchPrompts.init(root); } catch (e) { /* static placeholder remains */ }
    }

    /* Focus synchronously inside the user gesture so iOS opens the keyboard. */
    var input = root.querySelector('input[type="search"]');
    if (input) input.focus({ preventScroll: true });
  }

  function finishClose(root) {
    root.hidden = true;
  }

  function close() {
    var root = getOverlay();
    if (!root || root.hidden) return;

    root.classList.remove('is-open');
    document.documentElement.classList.remove('tg-search-open');
    document.body.classList.remove('tg-search-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    if (reduceMotion && reduceMotion.matches) {
      finishClose(root);
    } else {
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        root.removeEventListener('transitionend', onEnd);
        if (!root.classList.contains('is-open')) finishClose(root);
      };
      var onEnd = function (e) {
        if (e.target === root) finish();
      };
      root.addEventListener('transitionend', onEnd);
      hideTimer = setTimeout(finish, 400);
    }

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    } else if (trigger) {
      trigger.focus({ preventScroll: true });
    }
  }

  function trapFocus(e) {
    var root = overlay;
    if (!root || root.hidden || e.key !== 'Tab') return;
    var nodes = Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (n) {
      return n.offsetParent !== null || n === document.activeElement;
    });
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;
    if (!root.contains(active)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function init() {
    trigger = document.getElementById(TRIGGER_ID);
    if (!trigger || !getOverlay()) return;

    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');

    /* Capture phase on the document: runs before the <details> toggles and
       before search-drawer's own handlers, so the standard drawer never opens
       on phones. On desktop widths we do nothing and the default applies. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('#' + TRIGGER_ID)) return;
      if (!isMobile()) return;
      e.preventDefault();
      e.stopPropagation();
      closeNativeSearchDrawer();
      lastFocus = trigger;
      open();
    }, true);

    var closeBtn = overlay.querySelector('.tg-search-overlay__close');
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (!overlay || overlay.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      } else {
        trapFocus(e);
      }
    });

    /* Rotating past the breakpoint (e.g. tablet rotation) closes the overlay. */
    if (mq) {
      var onChange = function () { if (!mq.matches) close(); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
